import { type Tag } from 'src/services/apollo/generated/graphql'

export const extractTackIds = (tags?: Pick<Tag, 'id'>[]): string[] => {
  if (!tags) return []
  return (
    tags
      // `tag` cannot be nullish, but keeping the filter just in case
      .filter(tag => tag != null)
      .map(tag => tag.id)
      .filter((id): id is string => !!id)
  )
}
